import { RAW_UNDERGRADUATE_MAJORS } from './undergraduateMajors.data';

function buildMajors(): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const row of RAW_UNDERGRADUATE_MAJORS) {
    const name = row.trim();
    const key = name.toLowerCase();
    if (!name || seen.has(key)) continue;
    seen.add(key);
    out.push(name);
  }
  out.sort((a, b) => a.localeCompare(b));
  return out;
}

/** Deduplicated, sorted A–Z. */
export const UNDERGRADUATE_MAJORS: string[] = buildMajors();

export function filterMajors(query: string, limit = 100): string[] {
  const q = query.trim().toLowerCase();
  if (!q) return UNDERGRADUATE_MAJORS.slice(0, limit);
  const matches = UNDERGRADUATE_MAJORS.filter((m) => m.toLowerCase().includes(q));
  matches.sort((a, b) => {
    const al = a.toLowerCase();
    const bl = b.toLowerCase();
    const aStarts = al.startsWith(q) ? 0 : 1;
    const bStarts = bl.startsWith(q) ? 0 : 1;
    if (aStarts !== bStarts) return aStarts - bStarts;
    const ai = al.indexOf(q);
    const bi = bl.indexOf(q);
    if (ai !== bi) return ai - bi;
    return a.localeCompare(b);
  });
  return matches.slice(0, limit);
}
